<template>
    <div id="sidebar-parent" :class="[{ active: sidebar, mobile: mobileScreen }, 'd-flex', 'flex-row']" @click="handleParentClick">
        <div id="sidebar" :class="[{ active: sidebar, mobile: mobileScreen }, 'shadow', 'bg-menu']">
            <!-- PERFECT SCROLL -->
            <vuescroll :ops="opts">
                <div id="sidebar-header" class="p-3 text-center">
                    <slot name="header">
                        <!-- SIDEBAR HEADER CONTENT GOES HERE -->
                    </slot>
                </div>

                <!-- MENU CONTENT GOES HERE -->
                <slot>
                    <component
                        v-for="(opt, id) in options"
                        :is="opt.type"
                        v-bind="opt.data"
                        :key="id || opt.id"
                    ></component>
                </slot>

                <!-- add some div with margin bottom here -->
                <div id="sidebar-padding" style="height: 160px"></div>
            </vuescroll>
        </div>
        <div v-if="mobileScreen" id="close-sidenav" :class="[{ mobile: mobileScreen, active: sidebar }, 'p-2']">
            <b-button size="lg" v-show="sidebar" @click="setSidebarActive(false)">
                <font-awesome-icon icon="times" />
            </b-button>
        </div>
    </div>
</template>

<script>
import vuescroll from "vuescroll";
import { mapGetters, mapMutations } from "vuex";

import SideNavSection from "@/components/SideNavSection";
import SideNavItemList from "@/components/SideNavItemList";
import SideNavItem from "@/components/SideNavItem";

export default {
    components: {
        vuescroll,
        SideNavSection,
        SideNavItemList,
        SideNavItem,
    },
    props: {
        options: {
            type: Array,
            default: null,
        },
    },

    methods: {
        ...mapMutations(['setSidebarActive']),

        handleParentClick(e) {
            console.log(e)

            if (e.target.id == 'sidebar-parent') {
                this.setSidebarActive(false)
            }
        }
    },

    data() {
        return {
            opts: {
                bar: {
                    background: "#c2c2c2",
                },
            },
        };
    },

    computed: {
        ...mapGetters(["sidebar", 'mobileScreen']),
    },
};
</script>



// WEBPACK FOOTER //
// src/components/SideNav.vue